import {
  MantineProvider,
  VariantColorsResolver,
  defaultVariantColorsResolver,
} from '@mantine/core'

const variantColorResolver: VariantColorsResolver = (input) => {
  const defaultResolvedColors = defaultVariantColorsResolver(input)

  if (input.variant === 'high-priority') {
    return {
      background: 'rgba(238, 46, 49, 0.10)',
      hover: 'rgba(238, 46, 49, 0.10)',
      color: 'rgba(238, 46, 49)',
      border: 'none',
    }
  } else if (input.variant === 'medium-priority') {
    return {
      background: 'rgb(247, 176, 85, 0.10)',
      hover: 'rgb(247, 176, 85, 0.10)',
      color: 'rgb(247, 176, 85)',
      border: 'none',
    }
  } else if (input.variant === 'low-priority') {
    return {
      background: 'rgb(20, 186, 109, 0.1)',
      hover: 'rgb(20, 186, 109, 0.1)',
      color: 'rgb(20, 186, 109)',
      border: 'none',
    }
  } else if (input.variant === 'resolved-status') {
    return {
      background: 'rgb(140, 192, 132, 0.1)',
      hover: 'rgb(140, 192, 132, 0.1)',
      color: 'rgb(140, 192, 132)',
      border: 'none',
    }
  } else if (input.variant === 'review-status') {
    return {
      background: 'rgb(128, 193, 255, 0.1)',
      hover: 'rgb(128, 193, 255, 0.1)',
      color: 'rgb(128, 193, 255)',
      border: 'none',
    }
  } else if (input.variant === 'submitted-status') {
    return {
      background: 'rgb(115, 130, 144, 0.1)',
      hover: 'rgb(115, 130, 144, 0.1)',
      color: 'rgb(115, 130, 144)',
      border: 'none',
    }
  } else if (input.variant === 'pending-status') {
    return {
      background: 'rgb(216, 167, 202, 0.1)',
      hover: 'rgb(216, 167, 202, 0.1)',
      color: 'rgb(216, 167, 202)',
      border: 'none',
    }
  } else if (input.variant === 'sent-status') {
    return {
      background: 'rgb(244, 152, 156, 0.1)',
      hover: 'rgb(244, 152, 156, 0.1)',
      color: 'rgb(244, 152, 156)',
      border: 'none',
    }
  } else if (input.variant === 'draft-status') {
    return {
      background: 'rgb(226, 185, 127, 0.1)',
      hover: 'rgb(226, 185, 127, 0.1)',
      color: 'rgb(226, 185, 127)',
      border: 'none',
    }
  }

  return defaultResolvedColors
}

export const MantineProviderWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <MantineProvider theme={{ variantColorResolver }}>{children}</MantineProvider>
)
